import {
	useFreeIntent,
	useIsUpgradeEligible,
	usePremiumIntent,
	useStandardIntent,
} from '@/components/user-context/helpers/cohorts';

import { SignupDefault } from '../../components/signup-default';

import { LoggedInJsmFree } from './free/logged-in-jsm-free';
import { LoggedInJsmPremium } from './premium/logged-in-jsm-premium';
import { LoggedInJsmStandard } from './standard/logged-in-jsm-standard';

export const LoggedInJsm = () => {
	const isStandard = useStandardIntent();
	const isPremium = usePremiumIntent();
	const isFree = useFreeIntent();
	const isUpgradeEligible = useIsUpgradeEligible();

	if (isPremium && !isUpgradeEligible) {
		return <LoggedInJsmPremium />;
	}

	if (isStandard && !isUpgradeEligible) {
		return <LoggedInJsmStandard />;
	}

	if (isFree) {
		return <LoggedInJsmFree />;
	}

	// bxpkit catch-all
	return <SignupDefault />;
};
